module.exports = __webpack_public_path__ + "img/page9.217acb57.png";